/**
 * EduFlow — libellés des éditeurs de blocs (FR). Fusionné dans `frTranslations`.
 */

export const eduflowBlockEditorsEn: Record<string, string> = {
  'eduflow.blockEditor.audio.estimatedSeconds': '~{{sec}}s estimated',
  'eduflow.blockEditor.audio.fileLabel': 'Audio file',
  'eduflow.blockEditor.audio.formatsHint': 'MP3, WAV, OGG',
  'eduflow.blockEditor.audio.generateButton': 'Generate audio',
  'eduflow.blockEditor.audio.generateTts': 'Generate TTS',
  'eduflow.blockEditor.audio.import': 'Import',
  'eduflow.blockEditor.audio.langDe': 'German',
  'eduflow.blockEditor.audio.langEn': 'English',
  'eduflow.blockEditor.audio.langEs': 'Spanish',
  'eduflow.blockEditor.audio.langFr': 'French',
  'eduflow.blockEditor.audio.langIt': 'Italian',
  'eduflow.blockEditor.audio.language': 'Language',
  'eduflow.blockEditor.audio.mistralVoice': 'Voice (Mistral TTS)',
  'eduflow.blockEditor.audio.mistralVoicePlaceholder': 'Mistral voice ID (Mistral console / API)',
  'eduflow.blockEditor.audio.voicesLoading': 'Loading voices…',
  'eduflow.blockEditor.audio.voicesLoadError': 'Could not load Mistral voices.',
  'eduflow.blockEditor.audio.voicesEmptyHint':
    'The API returned no voices. Check the Mistral key (Administration → Integrations). Synthesis still uses a default voice.',
  'eduflow.blockEditor.audio.voiceFallbackOption': '{{id}} (default)',
  'eduflow.blockEditor.audio.generating': 'Generating…',
  'eduflow.blockEditor.audio.generateNeedText': 'Enter text to synthesize first.',
  'eduflow.blockEditor.audio.generateBadResponse': 'Invalid TTS response.',
  'eduflow.blockEditor.audio.generateSuccess': 'Audio generated.',
  'eduflow.blockEditor.audio.generateError': 'Synthesis failed (Mistral TTS / integrations).',
  'eduflow.blockEditor.audio.preview': 'Preview',
  'eduflow.blockEditor.audio.source': 'Audio source',
  'eduflow.blockEditor.audio.speedLabel': 'Speed: {{speed}}x',
  'eduflow.blockEditor.audio.syncWithText': 'Sync with text (subtitles)',
  'eduflow.blockEditor.audio.syncWithTextHelp':
    'In the player: a subtitle-style area under the waveform shows text in segments aligned to playback position (estimated split over audio duration; no VTT file).',
  'eduflow.blockEditor.audio.ttsPlaceholder': 'Enter the text to be read by the synthetic voice…',
  'eduflow.blockEditor.audio.ttsText': 'Text to synthesize',
  'eduflow.blockEditor.audio.urlLabel': 'Or audio file URL',
  'eduflow.blockEditor.audio.urlPlaceholder': 'https://example.com/audio.mp3',
  'eduflow.blockEditor.browser.allowExternalAria': 'Allow other websites',
  'eduflow.blockEditor.browser.allowExternalHelp': '{{off}}: protected iframe (sandbox) — limits pop-ups and outgoing behavior. {{on}}: better compatibility with rich pages (videos, widgets); navigation possible inside the frame.',
  'eduflow.blockEditor.browser.allowExternalOff': 'Off',
  'eduflow.blockEditor.browser.allowExternalOn': 'On',
  'eduflow.blockEditor.browser.allowExternalTitle': 'Allow other websites',
  'eduflow.blockEditor.browser.frameTitleFallback': 'Embedded web page',
  'eduflow.blockEditor.browser.fullscreen': 'Fullscreen',
  'eduflow.blockEditor.browser.fullscreenTitle': 'Preview — Embedded web page',
  'eduflow.blockEditor.browser.openTab': 'Open in a tab',
  'eduflow.blockEditor.browser.preview': 'Preview',
  'eduflow.blockEditor.browser.urlHelp': 'Enter the full address (https). Preview is framed like a window — this is not a browser: learners cannot change the URL here.',
  'eduflow.blockEditor.browser.urlLabel': 'Page URL',
  'eduflow.blockEditor.browser.urlPlaceholder': 'https://…',
  'eduflow.blockEditor.chart.addLabel': 'Label',
  'eduflow.blockEditor.chart.addSeries': 'Series',
  'eduflow.blockEditor.chart.animation': 'Animation',
  'eduflow.blockEditor.chart.chartTitle': 'Chart title',
  'eduflow.blockEditor.chart.chartType': 'Chart type',
  'eduflow.blockEditor.chart.colorTitle': 'Color',
  'eduflow.blockEditor.chart.datasets': 'Data series ({{count}})',
  'eduflow.blockEditor.chart.defaultLabel': 'Label {{n}}',
  'eduflow.blockEditor.chart.defaultSeries': 'Series {{n}}',
  'eduflow.blockEditor.chart.interactive': 'Interactive (tooltips)',
  'eduflow.blockEditor.chart.labelsX': 'Labels (X axis)',
  'eduflow.blockEditor.chart.noSeries': 'No series. Click “Series” to add one.',
  'eduflow.blockEditor.chart.readerPreviewHint': 'Preview available in player mode',
  'eduflow.blockEditor.chart.seriesNamePlaceholder': 'Series name',
  'eduflow.blockEditor.chart.settings': 'Settings',
  'eduflow.blockEditor.chart.showGrid': 'Show grid',
  'eduflow.blockEditor.chart.showLegend': 'Show legend',
  'eduflow.blockEditor.chart.titlePlaceholder': 'Optional title',
  'eduflow.blockEditor.chart.typeArea': 'Area',
  'eduflow.blockEditor.chart.typeBar': 'Bars',
  'eduflow.blockEditor.chart.typeDoughnut': 'Doughnut',
  'eduflow.blockEditor.chart.typeLine': 'Line',
  'eduflow.blockEditor.chart.typePie': 'Pie',
  'eduflow.blockEditor.chart.typeRadar': 'Radar',
  'eduflow.blockEditor.timer.sectionTitle': 'Timer',
  'eduflow.blockEditor.timer.enable': 'Enable timer (player)',
  'eduflow.blockEditor.timer.modeLabel': 'Mode',
  'eduflow.blockEditor.timer.modeCountup': 'Stopwatch (0 → limit)',
  'eduflow.blockEditor.timer.countupHint': 'The last 10 seconds before the limit turn red.',
  'eduflow.blockEditor.timer.modeCountdown': 'Countdown (limit → 0)',
  'eduflow.blockEditor.timer.countdownHint': 'The last 5 seconds turn red.',
  'eduflow.blockEditor.timer.maxSecondsLabel': 'Maximum time (seconds)',
  'eduflow.blockEditor.evaluation.aiQuestions': 'Generate questions with AI',
  'eduflow.blockEditor.evaluation.editFullscreen': 'Edit form (fullscreen)',
  'eduflow.blockEditor.evaluation.hint': 'Open the fullscreen editor to build the form: drag field types from the left column and reorder questions with the handle.',
  'eduflow.blockEditor.evaluation.metaLine': '{{qPart}} · {{pPart}} total',
  'eduflow.blockEditor.evaluation.pointPlural': 'points',
  'eduflow.blockEditor.evaluation.pointSingular': 'point',
  'eduflow.blockEditor.evaluation.questionPlural': 'questions',
  'eduflow.blockEditor.evaluation.questionSingular': 'question',
  'eduflow.blockEditor.evaluation.title': 'Assessment form',
  'eduflow.blockEditor.evaluationForm.addFreeText': 'Add free text',
  'eduflow.blockEditor.evaluationForm.addOption': 'Option',
  'eduflow.blockEditor.evaluationForm.close': 'Close',
  'eduflow.blockEditor.evaluationForm.delete': 'Delete',
  'eduflow.blockEditor.evaluationForm.dropEmptyHint': 'Drop a question type from the left panel here, or use the “Add” button.',
  'eduflow.blockEditor.evaluationForm.escapeHint': 'Esc to close',
  'eduflow.blockEditor.evaluationForm.expectedValue': 'Expected value',
  'eduflow.blockEditor.evaluationForm.footerStats': '{{n}} question(s) · {{pts}} pts total',
  'eduflow.blockEditor.evaluationForm.headerSubtitle': 'Drag a question type from the left into the center. Reorder with the ⋮⋮ handle.',
  'eduflow.blockEditor.evaluationForm.headerTitle': 'Assessment form editor',
  'eduflow.blockEditor.evaluationForm.maxAttempts': 'Max attempts',
  'eduflow.blockEditor.evaluationForm.moveQuestion': 'Move question',
  'eduflow.blockEditor.evaluationForm.optionPlaceholder': 'Option…',
  'eduflow.blockEditor.evaluationForm.optionsHint': 'Click the icon to mark the correct answer(s).',
  'eduflow.blockEditor.evaluationForm.overlayUntitled': '(untitled)',
  'eduflow.blockEditor.evaluationForm.paletteSubtitle': 'Drop on the canvas to add a question.',
  'eduflow.blockEditor.evaluationForm.paletteTitle': 'Fields',
  'eduflow.blockEditor.evaluationForm.passThreshold': 'Pass threshold: {{pct}}%',
  'eduflow.blockEditor.evaluationForm.pointsShort': 'pts',
  'eduflow.blockEditor.evaluationForm.qTypeDropdown': 'Dropdown',
  'eduflow.blockEditor.evaluationForm.qTypeFile': 'File',
  'eduflow.blockEditor.evaluationForm.qTypeMultiple': 'Multiple choice',
  'eduflow.blockEditor.evaluationForm.qTypeNumeric': 'Numeric',
  'eduflow.blockEditor.evaluationForm.qTypeSingle': 'Single choice',
  'eduflow.blockEditor.evaluationForm.qTypeText': 'Free text',
  'eduflow.blockEditor.evaluationForm.questionTitlePlaceholder': 'Question title…',
  'eduflow.blockEditor.evaluationForm.refAnswerLabel': 'Reference answer (optional)',
  'eduflow.blockEditor.evaluationForm.refAnswerPlaceholder': 'Expected answer…',
  'eduflow.blockEditor.evaluationForm.refEmptyHint': 'Without reference: any non-empty answer is accepted.',
  'eduflow.blockEditor.evaluationForm.required': 'Req.',
  'eduflow.blockEditor.evaluationForm.semanticGrading': 'AI grading (semantic similarity)',
  'eduflow.blockEditor.evaluationForm.semanticThreshold': 'Semantic threshold: {{pct}}%',
  'eduflow.blockEditor.evaluationForm.showCorrect': 'Show correct answers',
  'eduflow.blockEditor.evaluationForm.showResults': 'Show results',
  'eduflow.blockEditor.evaluationForm.timeLimit': 'Time limit',
  'eduflow.blockEditor.evaluationForm.tolerance': 'Tolerance ±',
  'eduflow.blockEditor.glossary.add': 'Add',
  'eduflow.blockEditor.glossary.categories': 'Categories',
  'eduflow.blockEditor.glossary.definitionPlaceholder': 'Definition',
  'eduflow.blockEditor.glossary.description': 'Description',
  'eduflow.blockEditor.glossary.descriptionPlaceholder': 'Help text for vocabulary…',
  'eduflow.blockEditor.glossary.enableQuiz': 'Enable built-in quiz',
  'eduflow.blockEditor.glossary.includeInQuiz': 'Include in quiz',
  'eduflow.blockEditor.glossary.newCategoryPlaceholder': 'New category',
  'eduflow.blockEditor.glossary.noCategory': 'No category',
  'eduflow.blockEditor.glossary.panelHint': 'Define your terms and enable quiz mode for review.',
  'eduflow.blockEditor.glossary.panelTitle': 'Glossary + built-in quiz',
  'eduflow.blockEditor.glossary.termPlaceholder': 'Term',
  'eduflow.blockEditor.glossary.termSingular': 'Term',
  'eduflow.blockEditor.glossary.termsCount': 'Terms ({{count}})',
  'eduflow.blockEditor.glossary.titleLabel': 'Glossary title',
  'eduflow.blockEditor.glossary.titlePlaceholder': 'Glossary',
  'eduflow.blockEditor.htmlSource.formatButton': 'Format',
  'eduflow.blockEditor.htmlSource.formatTitle': 'Re-indent and structure HTML (same logic as when entering code mode)',
  'eduflow.blockEditor.htmlSource.findVerb': 'find',
  'eduflow.blockEditor.htmlSource.indentVerb': 'indents',
  'eduflow.blockEditor.htmlSource.modeLabel': 'HTML code mode',
  'eduflow.blockEditor.mindmap.addChild': 'Child node',
  'eduflow.blockEditor.mindmap.addMainBranch': 'Add a main branch',
  'eduflow.blockEditor.mindmap.branchTitle': 'Branch · {{title}}',
  'eduflow.blockEditor.mindmap.centralTheme': 'Central theme',
  'eduflow.blockEditor.mindmap.close': 'Close',
  'eduflow.blockEditor.mindmap.configureFullscreen': 'Configure fullscreen',
  'eduflow.blockEditor.mindmap.descriptionLabel': 'Description',
  'eduflow.blockEditor.mindmap.descriptionPlaceholder': 'Supporting text',
  'eduflow.blockEditor.mindmap.dialogTitle': 'Mind map',
  'eduflow.blockEditor.mindmap.optional': 'Optional',
  'eduflow.blockEditor.mindmap.playerHint': 'Player: horizontal map (text on colored curve, pills). Zoom in the block header. URL: ↗ opens a new tab.',
  'eduflow.blockEditor.mindmap.remove': 'Remove',
  'eduflow.blockEditor.mindmap.structure': 'Structure',
  'eduflow.blockEditor.mindmap.subtitleLabel': 'Subtitle',
  'eduflow.blockEditor.mindmap.titleLabel': 'Title',
  'eduflow.blockEditor.mindmap.titlePlaceholder': 'Node title',
  'eduflow.blockEditor.mindmap.untitled': 'Untitled',
  'eduflow.blockEditor.mindmap.urlLabel': 'URL link',
  'eduflow.blockEditor.mindmap.urlPlaceholder': 'https://…',
  'eduflow.blockEditor.pdf.allowDownload': 'Allow download',
  'eduflow.blockEditor.pdf.badgePdf': 'PDF',
  'eduflow.blockEditor.pdf.completionLabel': 'Completion label',
  'eduflow.blockEditor.pdf.completionPlaceholder': 'Document viewed',
  'eduflow.blockEditor.pdf.documentFallback': 'PDF document',
  'eduflow.blockEditor.pdf.emptyLibrary': 'No documents in your library.',
  'eduflow.blockEditor.pdf.focusMode': 'Document focus',
  'eduflow.blockEditor.pdf.focusModeDesc': 'Minimal chrome, centered reading',
  'eduflow.blockEditor.pdf.importFailed': 'Import failed',
  'eduflow.blockEditor.pdf.importFailedGeneric': 'Import failed.',
  'eduflow.blockEditor.pdf.importSubtitle': 'The document will be added to your document library.',
  'eduflow.blockEditor.pdf.importTitle': 'Import a PDF',
  'eduflow.blockEditor.pdf.librarySubtitle': 'Upload a PDF to your library or pick an existing one.',
  'eduflow.blockEditor.pdf.libraryTitle': 'Document library',
  'eduflow.blockEditor.pdf.loadingDocs': 'Loading documents…',
  'eduflow.blockEditor.pdf.myDocuments': 'My documents',
  'eduflow.blockEditor.pdf.pagesAuto': 'The player will detect the number of pages automatically.',
  'eduflow.blockEditor.pdf.pagesDetected': '{{count}} pages detected',
  'eduflow.blockEditor.pdf.pickFromLibrary': 'Select a PDF already in your library.',
  'eduflow.blockEditor.pdf.previewTitle': 'Document preview',
  'eduflow.blockEditor.pdf.readerMode': 'Modern reader',
  'eduflow.blockEditor.pdf.readerModeDesc': 'Page by page, zoom, fullscreen',
  'eduflow.blockEditor.pdf.readingExperience': 'Reading experience',
  'eduflow.blockEditor.pdf.showProgress': 'Show reading progress',
  'eduflow.blockEditor.pdf.smartExtractSoon': 'Smart extraction coming soon',
  'eduflow.blockEditor.pdf.startPage': 'Start page',
  'eduflow.blockEditor.pdf.uploadedDesc': '{{name}} is now available in your document library.',
  'eduflow.blockEditor.pdf.uploadedToast': 'PDF imported',
  'eduflow.blockEditor.pdf.uploading': 'Upload in progress',
  'eduflow.blockEditor.phraseReveal.addPhrase': 'Add a phrase',
  'eduflow.blockEditor.phraseReveal.aiSummaryTitle': 'Generate an AI recap from upstream blocks',
  'eduflow.blockEditor.phraseReveal.autoScroll': 'Auto-scroll',
  'eduflow.blockEditor.phraseReveal.displayDuration': 'Duration per phrase (s)',
  'eduflow.blockEditor.phraseReveal.editorHint': 'Add one or more phrases with the rich text editor. The player shows one phrase at a time; click or Space for the next.',
  'eduflow.blockEditor.phraseReveal.emptyPhrase': 'Empty phrase',
  'eduflow.blockEditor.phraseReveal.importLegacy': 'Import the legacy “text to reveal” field as phrases (recommended).',
  'eduflow.blockEditor.phraseReveal.noPhrases': 'No phrases yet.',
  'eduflow.blockEditor.phraseReveal.phraseContent': 'Phrase content',
  'eduflow.blockEditor.phraseReveal.phrasePlaceholder': 'Enter this step\'s text…',
  'eduflow.blockEditor.phraseReveal.showHistory': 'Show phrase history',
  'eduflow.blockEditor.phraseReveal.showHistoryHelp': 'Previously seen phrases appear in a card between the current phrase and the block description.',
  'eduflow.blockEditor.presentation.addSlide': 'Slide',
  'eduflow.blockEditor.presentation.autoAdvance': 'Auto-advance',
  'eduflow.blockEditor.presentation.delayLabel': 'Delay: {{sec}}s',
  'eduflow.blockEditor.presentation.duplicateTitleSuffix': ' (copy)',
  'eduflow.blockEditor.presentation.globalSettings': 'Global settings',
  'eduflow.blockEditor.presentation.layoutImageText': 'Image + text',
  'eduflow.blockEditor.presentation.layoutTitleContent': 'Title + content',
  'eduflow.blockEditor.presentation.layoutTitleOnly': 'Title only',
  'eduflow.blockEditor.presentation.layoutTwoCol': 'Two columns',
  'eduflow.blockEditor.presentation.layoutVideoOnly': 'Video only',
  'eduflow.blockEditor.presentation.layoutVideoText': 'Text + video',
  'eduflow.blockEditor.presentation.loop': 'Loop',
  'eduflow.blockEditor.presentation.noSlides': 'No slides. Click to add one.',
  'eduflow.blockEditor.presentation.slideCount_one': '{{count}} slide',
  'eduflow.blockEditor.presentation.slideCount_other': '{{count}} slides',
  'eduflow.blockEditor.presentation.slideNumbers': 'Slide numbers',
  'eduflow.blockEditor.presentation.slidesHeading': 'Slides',
  'eduflow.blockEditor.presentation.transition': 'Transition',
  'eduflow.blockEditor.presentation.transitionFade': 'Fade',
  'eduflow.blockEditor.presentation.transitionNone': 'None',
  'eduflow.blockEditor.presentation.transitionSlide': 'Slide',
  'eduflow.blockEditor.presentation.transitionZoom': 'Zoom',
  'eduflow.blockEditor.quiz.addAnswer': 'Add an answer',
  'eduflow.blockEditor.quiz.addOrderingItem': 'Add an item',
  'eduflow.blockEditor.quiz.aiMcqTitle': 'Generate an MCQ with AI from upstream blocks',
  'eduflow.blockEditor.quiz.answerPlaceholder': 'Answer {{n}}',
  'eduflow.blockEditor.quiz.answersCount': 'Answers ({{count}}/10)',
  'eduflow.blockEditor.quiz.branching': 'Branching',
  'eduflow.blockEditor.quiz.correctAnswer': 'Correct answer',
  'eduflow.blockEditor.quiz.correctAnswerPlaceholder': 'Select…',
  'eduflow.blockEditor.quiz.explanation': 'Explanation',
  'eduflow.blockEditor.quiz.explanationPlaceholder': 'Additional explanation...',
  'eduflow.blockEditor.quiz.false': 'False',
  'eduflow.blockEditor.quiz.feedback': 'Feedback',
  'eduflow.blockEditor.quiz.ifCorrect': 'If correct →',
  'eduflow.blockEditor.quiz.ifIncorrect': 'If incorrect →',
  'eduflow.blockEditor.quiz.markAsCorrect': 'Mark as correct',
  'eduflow.blockEditor.quiz.markCorrect': 'Correct answer',
  'eduflow.blockEditor.quiz.msgCorrect': 'Message if correct',
  'eduflow.blockEditor.quiz.msgCorrectPlaceholder': 'Well done! That\'s correct.',
  'eduflow.blockEditor.quiz.msgIncorrect': 'Message if incorrect',
  'eduflow.blockEditor.quiz.msgIncorrectPlaceholder': 'That\'s not the right answer.',
  'eduflow.blockEditor.quiz.nextBlockAuto': 'Next block (auto)',
  'eduflow.blockEditor.quiz.orderingHint': 'Items to order (current order = correct order)',
  'eduflow.blockEditor.quiz.orderingItemPlaceholder': 'Item {{n}}',
  'eduflow.blockEditor.quiz.partialScoring': 'Partial scoring (MCQ)',
  'eduflow.blockEditor.quiz.question': 'Question',
  'eduflow.blockEditor.quiz.questionPlaceholder': 'Enter your question...',
  'eduflow.blockEditor.quiz.quizType': 'Quiz type',
  'eduflow.blockEditor.quiz.score': 'Score',
  'eduflow.blockEditor.quiz.showCorrect': 'Show correct answer',
  'eduflow.blockEditor.quiz.shuffle': 'Shuffle',
  'eduflow.blockEditor.quiz.true': 'True',
  'eduflow.blockEditor.quiz.typeMcq': 'MCQ',
  'eduflow.blockEditor.quiz.typeFillBlank': 'Fill in the blanks',
  'eduflow.blockEditor.quiz.typeOrdering': 'Ordering',
  'eduflow.blockEditor.quiz.typeTrueFalse': 'True / False',
  'eduflow.blockEditor.quiz.branchingMode': 'Branching mode',
  'eduflow.blockEditor.quiz.branchingNone': 'None (linear)',
  'eduflow.blockEditor.quiz.branchingCorrectIncorrect': 'Correct / Incorrect',
  'eduflow.blockEditor.quiz.branchingPerAnswer': 'Per individual answer',
  'eduflow.blockEditor.loop.maxIterationsLabel': 'Maximum number of iterations (0 = infinite)',
  'eduflow.blockEditor.loop.infiniteHint': 'The loop will continue indefinitely until the exit condition is met',
  'eduflow.blockEditor.loop.limitedHint': 'The loop will stop after at most {{count}} iteration(s)',
  'eduflow.blockEditor.loop.howItWorksTitle': 'How it works:',
  'eduflow.blockEditor.loop.howItWorksText':
    'Connect the "Loop" output to the block to repeat until the max iteration count is reached (0 = no cap). Connect "End" to where the learner should go when exiting the loop.',
  'eduflow.blockEditor.selfAssessment.addBadge': 'Add',
  'eduflow.blockEditor.selfAssessment.addCriterion': 'Add',
  'eduflow.blockEditor.selfAssessment.badgeInputPlaceholder': 'e.g. Often, Never, Sometimes…',
  'eduflow.blockEditor.selfAssessment.badgeOptionsHint': 'Short words or phrases — learners pick them as chips. If none → free text field.',
  'eduflow.blockEditor.selfAssessment.badgeOptionsLabel': 'Options (badges)',
  'eduflow.blockEditor.selfAssessment.criteriaSection': 'Criteria',
  'eduflow.blockEditor.selfAssessment.criterionDescription': 'Description (optional)',
  'eduflow.blockEditor.selfAssessment.criterionDescriptionPh': 'Clarify what the learner should notice or how to position themselves…',
  'eduflow.blockEditor.selfAssessment.criterionTitle': 'Title',
  'eduflow.blockEditor.selfAssessment.criterionTitlePh': 'e.g. Communication, Autonomy…',
  'eduflow.blockEditor.selfAssessment.emptyCriteria': 'No criteria yet. Add at least one so learners can self-assess.',
  'eduflow.blockEditor.selfAssessment.moveDown': 'Move down',
  'eduflow.blockEditor.selfAssessment.moveUp': 'Move up',
  'eduflow.blockEditor.selfAssessment.panelHint': 'Define each dimension to rate: a short title and, if needed, a description to guide the learner.',
  'eduflow.blockEditor.selfAssessment.panelTitle': 'Self-assessment',
  'eduflow.blockEditor.selfAssessment.removeBadge': 'Remove',
  'eduflow.blockEditor.selfAssessment.removeCriterion': 'Remove this criterion',
  'eduflow.blockEditor.selfAssessment.responseTypeLabel': 'Response type',
  'eduflow.blockEditor.selfAssessment.scaleHint': 'From 1 to N (e.g. 5 = Likert)',
  'eduflow.blockEditor.selfAssessment.scaleLabel': 'Rating scale',
  'eduflow.blockEditor.selfAssessment.starCountHint': 'Often 5',
  'eduflow.blockEditor.selfAssessment.starCountLabel': 'Number of stars',
  'eduflow.blockEditor.selfAssessment.textModeHint': 'Per criterion: add badge options (selection) or leave empty for a written answer. The global comment stays below criteria in the player.',
  'eduflow.blockEditor.selfAssessment.typeNumeric': 'Numbers',
  'eduflow.blockEditor.selfAssessment.typeNumericHint': 'Buttons 1 to N',
  'eduflow.blockEditor.selfAssessment.typeStars': 'Stars',
  'eduflow.blockEditor.selfAssessment.typeStarsHint': 'Visual rating',
  'eduflow.blockEditor.selfAssessment.typeText': 'Free text',
  'eduflow.blockEditor.selfAssessment.typeTextHint': 'Written answer per criterion',
  'eduflow.blockEditor.shared.alignCenter': 'Center',
  'eduflow.blockEditor.shared.alignLeft': 'Align left',
  'eduflow.blockEditor.shared.alignRight': 'Align right',
  'eduflow.blockEditor.shared.annotationCount_one': '{{count}} annotation',
  'eduflow.blockEditor.shared.annotationCount_other': '{{count}} annotations',
  'eduflow.blockEditor.shared.blocksCount': '{{count}} blocks',
  'eduflow.blockEditor.shared.bold': 'Bold',
  'eduflow.blockEditor.shared.border': 'Border',
  'eduflow.blockEditor.shared.bulletList': 'Bullet list',
  'eduflow.blockEditor.shared.cancel': 'Cancel',
  'eduflow.blockEditor.shared.choose': 'Choose',
  'eduflow.blockEditor.shared.close': 'Close',
  'eduflow.blockEditor.shared.configure': 'Configure',
  'eduflow.blockEditor.shared.delete': 'Delete',
  'eduflow.blockEditor.shared.duplicate': 'Duplicate',
  'eduflow.blockEditor.shared.imageLabel': 'Image',
  'eduflow.blockEditor.shared.italic': 'Italic',
  'eduflow.blockEditor.shared.layoutPrefix': 'Layout: ',
  'eduflow.blockEditor.shared.linked': 'Linked',
  'eduflow.blockEditor.shared.maxAttempts': 'Max attempts',
  'eduflow.blockEditor.shared.mediaImage': ' Image',
  'eduflow.blockEditor.shared.mediaNone': ' No media',
  'eduflow.blockEditor.shared.mediaVideo': ' Video',
  'eduflow.blockEditor.shared.minutes': 'Minutes',
  'eduflow.blockEditor.shared.noImage': 'No image',
  'eduflow.blockEditor.shared.numberedList': 'Numbered list',
  'eduflow.blockEditor.shared.option': 'Option',
  'eduflow.blockEditor.shared.pages': '{{count}} pages',
  'eduflow.blockEditor.shared.points': 'Points',
  'eduflow.blockEditor.shared.retry': 'Retry',
  'eduflow.blockEditor.shared.rounded': 'Rounded corners',
  'eduflow.blockEditor.shared.save': 'Save',
  'eduflow.blockEditor.shared.selected': 'Selected',
  'eduflow.blockEditor.shared.shadow': 'Shadow',
  'eduflow.blockEditor.shared.slideCounter': 'Slide {{index}}/{{total}}',
  'eduflow.blockEditor.shared.speedTicks': '{{v}}x',
  'eduflow.blockEditor.shared.strike': 'Strikethrough',
  'eduflow.blockEditor.shared.underline': 'Underline',
  'eduflow.blockEditor.shared.untitledSlide': 'Untitled',
  'eduflow.blockEditor.shared.updatedOn': 'Updated {{date}}',
  'eduflow.blockEditor.subflow.emptyPublished': 'No published training available',
  'eduflow.blockEditor.subflow.emptySearch': 'No training found',
  'eduflow.blockEditor.subflow.linkedTraining': 'Linked sub-training',
  'eduflow.blockEditor.subflow.loadError': 'Could not load trainings',
  'eduflow.blockEditor.subflow.loading': 'Loading…',
  'eduflow.blockEditor.subflow.openInTab': 'Open sub-training in a new tab',
  'eduflow.blockEditor.subflow.remove': 'Remove',
  'eduflow.blockEditor.subflow.searchPlaceholder': 'Search a published training…',
  'eduflow.blockEditor.summary.addItem': 'Add a bullet',
  'eduflow.blockEditor.summary.aiRecapTitle': 'Generate an AI recap from upstream blocks',
  'eduflow.blockEditor.summary.editorHint': 'List concepts or steps seen in the training. Each line appears as a bullet in the player.',
  'eduflow.blockEditor.summary.emptyList': 'No bullets yet. Add one.',
  'eduflow.blockEditor.summary.itemPlaceholder': 'e.g. Workplace fire risks',
  'eduflow.blockEditor.text.audioTts': 'Audio (TTS)',
  'eduflow.blockEditor.text.charWordCount': '{{chars}} characters · {{words}} words',
  'eduflow.blockEditor.text.content': 'Content',
  'eduflow.blockEditor.text.contentPlaceholder': 'Enter the text block content…',
  'eduflow.blockEditor.text.formatting': 'Formatting',
  'eduflow.blockEditor.text.headingH1': 'Heading 1',
  'eduflow.blockEditor.text.headingH2': 'Heading 2',
  'eduflow.blockEditor.text.headingH3': 'Heading 3',
  'eduflow.blockEditor.text.headingH4': 'Heading 4',
  'eduflow.blockEditor.text.headingH5': 'Heading 5',
  'eduflow.blockEditor.text.headingH6': 'Heading 6',
  'eduflow.blockEditor.text.headingLevel': 'Heading level',
  'eduflow.blockEditor.text.headingParagraph': 'Paragraph',
  'eduflow.blockEditor.text.previewSoon': 'Preview (coming soon)',
  'eduflow.blockEditor.text.readTime': '~{{min}} min read',
  'eduflow.blockEditor.text.speedLabel': 'Speed: {{speed}}x',
  'eduflow.blockEditor.text.voice': 'Voice',
  'eduflow.blockEditor.text.voiceAdam': 'Adam (French male)',
  'eduflow.blockEditor.text.voiceBella': 'Bella (French female)',
  'eduflow.blockEditor.text.voiceHeart': 'Heart (French female)',
  'eduflow.blockEditor.text.voiceMichael': 'Michael (English male)',
  'eduflow.blockEditor.text.voiceNova': 'Nova (English female)',
  'eduflow.blockEditor.text.voiceSky': 'Sky (English female)',
  'eduflow.blockEditor.timeline.addEvent': 'Event',
  'eduflow.blockEditor.timeline.alternatingSides': 'Alternating sides',
  'eduflow.blockEditor.timeline.animatedReveal': 'Animated reveal',
  'eduflow.blockEditor.timeline.colorHint': 'Dot color (optional)',
  'eduflow.blockEditor.timeline.colorLabel': 'Color',
  'eduflow.blockEditor.timeline.datePlaceholder': 'Date or period (e.g. 1789, Jan 2024)',
  'eduflow.blockEditor.timeline.descPlaceholder': 'Description (shown when expanded)',
  'eduflow.blockEditor.timeline.emptyEvents': 'No events yet. Add one to build the timeline.',
  'eduflow.blockEditor.timeline.events': 'Events',
  'eduflow.blockEditor.timeline.horizontal': 'Horizontal',
  'eduflow.blockEditor.timeline.iconAward': 'Award',
  'eduflow.blockEditor.timeline.iconCheck': 'Check',
  'eduflow.blockEditor.timeline.iconClock': 'Clock',
  'eduflow.blockEditor.timeline.iconFlag': 'Flag',
  'eduflow.blockEditor.timeline.iconStar': 'Star',
  'eduflow.blockEditor.timeline.moveDown': 'Move down',
  'eduflow.blockEditor.timeline.moveUp': 'Move up',
  'eduflow.blockEditor.timeline.orientation': 'Orientation',
  'eduflow.blockEditor.timeline.settings': 'Settings',
  'eduflow.blockEditor.timeline.showConnectors': 'Connector lines',
  'eduflow.blockEditor.timeline.titlePlaceholder': 'Event title',
  'eduflow.blockEditor.timeline.untitled': 'Untitled',
  'eduflow.blockEditor.timeline.vertical': 'Vertical',
  'eduflow.blockEditor.videoSubtitles.cancel': 'Cancel',
  'eduflow.blockEditor.videoSubtitles.invalidResponse': 'Invalid server response.',
  'eduflow.blockEditor.videoSubtitles.invalidUrl': 'Invalid track URL.',
  'eduflow.blockEditor.videoSubtitles.loadError': 'Could not load.',
  'eduflow.blockEditor.videoSubtitles.loadFailed': 'Could not load track ({{status}}).',
  'eduflow.blockEditor.videoSubtitles.loading': 'Loading segments…',
  'eduflow.blockEditor.videoSubtitles.modalSubtitle': 'One block per screen appearance. Timing is preserved; only text can be edited.',
  'eduflow.blockEditor.videoSubtitles.modalTitle': 'Edit subtitles',
  'eduflow.blockEditor.videoSubtitles.noSegments': 'No readable segments in the subtitle file.',
  'eduflow.blockEditor.videoSubtitles.saveFailed': 'Could not save.',
  'eduflow.blockEditor.videoSubtitles.saveTrack': 'Save track',
  'eduflow.blockEditor.videoSubtitles.savedToast': 'Subtitles saved',
  'eduflow.blockEditor.videoSubtitles.segmentN': 'Segment {{n}}',
  'eduflow.blockEditor.videoSubtitles.segmentRequiredToast': 'At least one segment with text is required.',
  'eduflow.blockEditor.videoSubtitles.trackLang': 'Track language: {{label}}',
  'eduflow.designer.blockLabel.audio': 'Audio',

  /** Video block editor */
  'eduflow.blockEditor.video.autoCaptionBullet':
    'Audio extraction (ffmpeg) then Mistral transcription. Direct .mp4 URL recommended; not a YouTube page.',
  'eduflow.blockEditor.video.autoCaptionErrorFallback':
    'Check the Mistral key, ffmpeg on the server, and that the video contains audio.',
  'eduflow.blockEditor.video.autoCaptionSection': 'Automatic subtitles',
  'eduflow.blockEditor.video.autoCaptionsButton': 'Generate subtitles (audio + AI)',
  'eduflow.blockEditor.video.availableSubtitlesChip': 'Subtitles available',
  'eduflow.blockEditor.video.completionThreshold': 'Completion threshold (%)',
  'eduflow.blockEditor.video.editCueButton': 'Edit subtitles (per segment)',
  'eduflow.blockEditor.video.endSeconds': 'End (sec)',
  'eduflow.blockEditor.video.escHint': 'Esc to close',
  'eduflow.blockEditor.video.libraryEmpty': 'No videos available in your library.',
  'eduflow.blockEditor.video.libraryTitle': 'Video library',
  'eduflow.blockEditor.video.libraryHint': 'Pick a video already uploaded in your designer dashboard.',
  'eduflow.blockEditor.video.libraryLoading': 'Loading videos…',
  'eduflow.blockEditor.video.optionalEnd': 'Optional',
  'eduflow.blockEditor.video.accent.primary': 'Primary',
  'eduflow.blockEditor.video.aspectFormat': 'Aspect ratio',
  'eduflow.blockEditor.video.aspect.ratio169': '16:9',
  'eduflow.blockEditor.video.aspect.ratio219': '21:9',
  'eduflow.blockEditor.video.aspect.ratio43': '4:3',
  'eduflow.blockEditor.video.aspect.ratio11': '1:1',
  'eduflow.blockEditor.video.pickFromLibrary': 'Select',
  'eduflow.blockEditor.video.playerBadge': 'Video player',
  'eduflow.blockEditor.video.previewTitleFallback': 'Video player',
  'eduflow.blockEditor.video.reduced': 'Minimize',
  'eduflow.blockEditor.video.regenerateCaptions': 'Regenerate',
  'eduflow.blockEditor.video.previewHint': 'Upload, YouTube, or direct URL with customisable styling.',
  'eduflow.blockEditor.video.previewIframeTitle': 'Video preview',
  'eduflow.blockEditor.video.subtitleBadge': 'Subtitles',
  'eduflow.blockEditor.video.selected': 'Selected',
  'eduflow.blockEditor.video.designTab': 'Design',
  'eduflow.blockEditor.video.radius.soft': 'Soft',
  'eduflow.blockEditor.video.radius.rounded': 'Rounded',
  'eduflow.blockEditor.video.radius.square': 'Square',
  'eduflow.blockEditor.video.shadow.soft': 'Soft',
  'eduflow.blockEditor.video.shadow.glow': 'Glow',
  'eduflow.blockEditor.video.shadow.dramatic': 'Dramatic',
  'eduflow.blockEditor.video.shadowLabel': 'Shadow',
  'eduflow.blockEditor.video.radiusCornerLabel': 'Corners',
  'eduflow.blockEditor.video.themeEditorial.desc': 'Light, clean, institutional',
  'eduflow.blockEditor.video.themeEditorial.label': 'Editorial',
  'eduflow.blockEditor.video.themeCinema.desc': 'Dark, premium, immersive',
  'eduflow.blockEditor.video.themeCinema.label': 'Cinema',
  'eduflow.blockEditor.video.themeGlass.desc': 'Translucent, modern, bright',
  'eduflow.blockEditor.video.themeGlass.label': 'Glass',
  'eduflow.blockEditor.video.themeApp.desc': 'Default, aligned with the current theme',
  'eduflow.blockEditor.video.themeApp.label': 'Application',
  'eduflow.blockEditor.video.themeAccent': 'Accent color',
  'eduflow.blockEditor.video.themePlayer': 'Player theme',
  'eduflow.blockEditor.video.toast.autoCaptionsError': 'Automatic subtitles unavailable',
  'eduflow.blockEditor.video.toast.autoCaptionsOk': 'Subtitles generated',
  'eduflow.blockEditor.video.toast.autoCaptionsOkDesc':
    'They appear in real time during playback in the player.',
  'eduflow.blockEditor.video.toast.uploadErrorDesc': 'Import failed.',
  'eduflow.blockEditor.video.toast.uploadErrorTitle': 'Could not import',
  'eduflow.blockEditor.video.toast.uploadedDesc': '{{name}} is ready in your video block.',
  'eduflow.blockEditor.video.toast.uploadedTitle': 'Video imported',
  'eduflow.blockEditor.video.fullscreenExpandTitle': 'Open fullscreen',
  'eduflow.blockEditor.video.fullscreenHeading': 'Video block',
  'eduflow.blockEditor.video.importDragTitle': 'Import a video',
  'eduflow.blockEditor.video.importFormats': 'MP4, WebM, OGG, MOV · max {{maxMb}} MB in the UI',
  'eduflow.blockEditor.video.noneSelected': 'No video selected',
  'eduflow.blockEditor.video.playbackTab': 'Playback',
  'eduflow.blockEditor.video.playbackSettingsTitle': 'Playback settings',
  'eduflow.blockEditor.video.loop': 'Loop',
  'eduflow.blockEditor.video.autoplay': 'Autoplay',
  'eduflow.blockEditor.video.mutedStart': 'Muted on start',
  'eduflow.blockEditor.video.showControls': 'Show controls',
  'eduflow.blockEditor.video.embedSubtitlesYoutubeVimeo':
    'On {{platform}}, enable subtitles in the embedded player (CC). The player loads tracks provided by the platform.',
  'eduflow.blockEditor.video.trackReadyHint':
    'WebVTT track ready: in the player, subtitles follow the learner’s chosen language (all 10 player languages; translated on the fly if needed).',
  'eduflow.blockEditor.video.langTranscriptionTrack': 'Language (transcription / source track)',
  'eduflow.blockEditor.video.placeholderUrlGeneric': 'https://example.com/video.mp4',
  'eduflow.blockEditor.video.placeholderVimeo': 'https://vimeo.com/…',
  'eduflow.blockEditor.video.placeholderYoutube': 'https://www.youtube.com/watch?v=…',
  'eduflow.blockEditor.video.invalidUrlSource': 'Invalid URL for this source',
  'eduflow.blockEditor.video.urlHelpDirect': 'Works with direct URLs to a video file.',
  'eduflow.blockEditor.video.labelUrlGeneric': 'Video URL',
  'eduflow.blockEditor.video.labelUrlVimeo': 'Vimeo URL',
  'eduflow.blockEditor.video.labelUrlYoutube': 'YouTube URL',
  'eduflow.blockEditor.video.readyInBlock': 'Video ready in block',
  'eduflow.blockEditor.video.uploadInProgress': 'Upload in progress',
  'eduflow.blockEditor.video.sectionSubtitlesDesign': 'Subtitles',
  'eduflow.blockEditor.video.sourceLabel': 'Video source',
  'eduflow.blockEditor.video.sourceTab': 'Source',
  'eduflow.blockEditor.video.sourceUrl': 'URL',
  'eduflow.blockEditor.video.sourceUpload': 'File',
  'eduflow.blockEditor.video.startSeconds': 'Start (sec)',
  'eduflow.blockEditor.video.showPlayerHeader': 'Show player header',
  'eduflow.blockEditor.video.accent.amber': 'Amber',
  'eduflow.blockEditor.video.accent.emerald': 'Emerald',

  /** Rich text (description / TipTap) */
  'eduflow.blockEditor.richText.collapsedHintHtml': 'Minimize editor (HTML mode on)',
  'eduflow.blockEditor.richText.collapsedHintReopen': 'Click to reopen the editor',
  'eduflow.blockEditor.richText.defaultPlaceholder': 'Write your content here…',
  'eduflow.blockEditor.richText.fullscreenTitleFallback': 'Editor',
  'eduflow.blockEditor.richText.calloutBody': 'Your text here…',
  'eduflow.blockEditor.richText.calloutTitle': 'Highlight title',
  'eduflow.blockEditor.richText.fullscreen': 'Fullscreen',
  'eduflow.blockEditor.richText.highlight': 'Highlight',
  'eduflow.blockEditor.richText.imageTab': 'Image',
  'eduflow.blockEditor.richText.importTab': 'Import',
  'eduflow.blockEditor.richText.infoPanelBody': 'Add key information for learners.',
  'eduflow.blockEditor.richText.infoPanelTitle': 'Good to know',
  'eduflow.blockEditor.richText.inlineCode': 'Inline code',
  'eduflow.blockEditor.richText.insertBadge': 'Badge',
  'eduflow.blockEditor.richText.insertCallout': 'Callout',
  'eduflow.blockEditor.richText.insertCalloutCompact': 'Insert callout',
  'eduflow.blockEditor.richText.insertImage': 'Insert image',
  'eduflow.blockEditor.richText.insertImageAction': 'Insert image',
  'eduflow.blockEditor.richText.insertInfoPanel': 'Info panel',
  'eduflow.blockEditor.richText.insertVideo': 'Insert video',
  'eduflow.blockEditor.richText.insertVideoAction': 'Insert video',
  'eduflow.blockEditor.richText.libraryTab': 'My images',
  'eduflow.blockEditor.richText.link': 'Link',
  'eduflow.blockEditor.richText.linkOk': 'OK',
  'eduflow.blockEditor.richText.linkPlaceholderHttps': 'https://…',
  'eduflow.blockEditor.richText.linkPrompt': 'Link URL:',
  'eduflow.blockEditor.richText.mediaFormatsHint': 'PNG, JPG, GIF, WebP · max 10 MB',
  'eduflow.blockEditor.richText.minimizeToolbar': 'Minimize',
  'eduflow.blockEditor.richText.modalLibraryEmpty': 'No images in your library',
  'eduflow.blockEditor.richText.modalUploading': 'Uploading…',
  'eduflow.blockEditor.richText.openImportTab': 'Import an image',
  'eduflow.blockEditor.richText.placeholderImageUrl': 'https://example.com/image.jpg',
  'eduflow.blockEditor.richText.placeholderYoutube': 'https://youtube.com/watch?v=…',
  'eduflow.blockEditor.richText.quote': 'Quote',
  'eduflow.blockEditor.richText.redo': 'Redo',
  'eduflow.blockEditor.richText.separatorRule': 'Divider',
  'eduflow.blockEditor.richText.showHtmlSource': 'Show / edit HTML',
  'eduflow.blockEditor.richText.returnToVisual': 'Return to visual editor',
  'eduflow.blockEditor.richText.tplBadgeLabel': 'Badge',
  'eduflow.blockEditor.richText.uploadDropPrompt': 'Drag and drop or',
  'eduflow.blockEditor.richText.uploadDropClick': 'click to select',
  'eduflow.blockEditor.richText.heading1': 'Heading 1',
  'eduflow.blockEditor.richText.heading2': 'Heading 2',
  'eduflow.blockEditor.richText.heading3': 'Heading 3',
  'eduflow.blockEditor.richText.justify': 'Justify',
  'eduflow.blockEditor.richText.undo': 'Undo',
  'eduflow.blockEditor.richText.videoYoutubePaste': 'Paste the YouTube URL below',
  'eduflow.blockEditor.richText.videoYoutubeToolbar': 'YouTube video',
  'eduflow.blockEditor.richText.urlTab': 'URL',
};
